import React from 'react';
// import Header from '../MyComponent/Header';
import Banner from '../MyComponent/Banner'
import Cards from '../MyComponent/Card'
import Seller from '../MyComponent/Sellers'
import Makingunique from '../MyComponent/Makingunique'
import Silder from '../MyComponent/SilderCart'

// import Footer from '../MyComponent/footer';

const Home = () => {
    return (
        <>
            <Banner />
            <Cards />
            <Seller />
            <Makingunique />
            <Silder />
        </>
    );
};

export default Home;
